module.exports = __webpack_public_path__ + "static/media/A2.16bf8994.jpg";